import { Box, ModalDialog, ModBox, Text } from '@jfs/ui-new'
import React, { useEffect, useState } from 'react'
import { useStores } from '../../../../data/store'
import { SelectParentEntityList } from '../../Onboarding/CreateEntity/SelectParentEntityList'
import { TIDDetails } from './Details'

const columnSize: any = {
  0: 1,
  1: 1,
  2: 1,
}
const headerTitle = [{ title: 'TID ID' }, { title: 'DSN' }, { title: 'Status' }]

const TIDList = ({ selectedEntity, type, from }: any) => {
  const { getTidList, searchedMasMid, getMakerCheckerTidList } = useStores((store) => ({
    getTidList: store.onboarding.getTidList,
    searchedMasMid: store.onboarding.searchedMasMid,
    getMakerCheckerTidList: store.onboarding.getMakerCheckerTidList,
  }))

  const [showDetails, setShowDetails] = useState(false)
  const [selectedTid, setSelectedTid] = useState('')
  const [list, setTidList] = useState([])

  useEffect(() => {
    if ((selectedEntity && selectedEntity.id) || (searchedMasMid && searchedMasMid.length > 0)) {
      const listData = getTidList(selectedEntity?.id ?? searchedMasMid, type)
      setTidList(listData)
    } else if (selectedEntity && selectedEntity?.applicationId) {
      const listData = getMakerCheckerTidList(selectedEntity)
      setTidList(listData)
    }
  }, [getMakerCheckerTidList, getTidList, searchedMasMid, selectedEntity, type])

  const closeModal = () => {
    setShowDetails(false)
  }

  const renderDetails = (): React.ReactElement => {
    const onStatusChange = () => {}
    return (
      <TIDDetails
        entityId={
          selectedEntity?.id?.length > 0
            ? selectedEntity?.id
            : searchedMasMid?.length > 0
            ? searchedMasMid
            : selectedEntity?.identificationNumber
        }
        tid={selectedTid}
        onClose={closeModal}
        onStatusChange={onStatusChange}
        type={type}
        from={from}
      />
    )
  }

  const onRowPress = (data: any) => {
    setShowDetails(true)
    setSelectedTid(data?.tid)
  }

  return (
    <Box f={1} overflow={'auto'} ph={40} pv={40} backgroundColor={'WHITE'} nativeID="vertical-scroll">
      <ModalDialog children={renderDetails()} show={showDetails} type={'Right'} onDismiss={closeModal} />
      <ModBox>
        <Box direction="row" w={'100%'} justifyContent={'space-between'} marginBottom={16}>
          <Box direction="row">
            <Text title={'TID List'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
          </Box>
        </Box>
        <SelectParentEntityList
          hide={false}
          title={''}
          data={list}
          columnFlexMapper={columnSize}
          headerTitles={headerTitle}
          onItemPress={onRowPress}
        />
      </ModBox>
    </Box>
  )
}

export { TIDList }
